import VueCookies from 'vue-cookies';

export const ACCESS_TOKEN = VueCookies.get('lmsAccessToken');
export const CSRF_TOKEN = '';
export const XSRF_TOKEN = '';

export const MICROSOFT_MSAL_REDIRECT = process.env.VUE_APP_MICROSOFT_MSAL_REDIRECT;
export const API_URL = process.env.VUE_APP_API_URL;
export const TENANT_API_URL = process.env.VUE_APP_TENANT_API_URL;
export const CENTRAL_API_URL = process.env.VUE_APP_CENTRAL_API_URL;
export const API_V4_URL = process.env.VUE_APP_API_V4_URL;
export const DEFAULT_BASE_URL = process.env.VUE_APP_DEFAULT_BASE_URL;
export const SOCKET_AUTH_URL = process.env.VUE_APP_SOCKET_AUTH_URL;
export const SOCKET_KEY = 339;
export const WEBSOCKET_HOST = 9000;
export const WEBSOCKET_PORT = process.env.VUE_APP_WEBSOCKET_PORT;
export const SPACES_URL = process.env.VUE_APP_SPACES_URL;
export const AWS_URL = process.env.VUE_APP_AWS_URL;
export const VUE_APP_CLIENT_ID = 2;
export const VUE_APP_CLIENT_SECRET = "p8AUx5QIQixjpFUb1n8ENkR2ePkXuLRRAAYMaMM7";

export const logOutRoutesOnly = [
    'auth.login',
    'auth.login.tenant',
    'auth.register',
    'auth.forgot-password',
    'auth.new-password',
];

export const allAreWelcome = [
    'auth.external-login',
];
